export default class OthercommonTrendService {
  getAll(otype) {
    return fetch("https://api.tradersr.com/api/othercommontrend?otype=" + otype)
      .then(res => res.json());
  }
}